export default {
  rideOption: "RideOption",
  AddRideOption: "AddRideOption",
  editRideOption: "EditRideOption",
};
